import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { useParams } from "react-router";

import Loading from "../../components/Loading";
import {
  getHumansCount,
  getMatchHumanId,
  getSelectedHuman,
} from "../../selectors/index";
import { createLoadingState } from "../../utils/selectors";
import HumanColumn from "./HumanColumn";
import HumanListColumn from "./HumanListColumn";
import NewHuman from "./NewHuman";

const getLoadingState = createLoadingState(["humans"]);

const mapStateToProps = (state, props) => ({
  ...getLoadingState(state),
  humansCount: getHumansCount(state),
  selectedHumanId: getMatchHumanId(state, props),
  selectedHuman: getSelectedHuman(state, props),
});
function Humans(props) {
  const {
    location,
    humansCount,
    loadingHumans,
    selectedHumanId,
    selectedHuman,
  } = props;
  const isNewForm = location.pathname.startsWith("/h/new/");

  const urlParams = useParams();
  const initialTitleRef = useRef(document.title);

  useEffect(() => {
    const initialTitle = initialTitleRef.current;
    return () => {
      document.title = initialTitle;
    };
  }, []);

  useEffect(() => {
    const baseTitle = "Humans.io";
    const isViewingHuman = !!urlParams.humanId;
    const shouldSetHumanTitle = isViewingHuman || isNewForm;
    const name =
      (selectedHuman?.name || "").trim() || (isNewForm ? "New Human" : "");

    if (shouldSetHumanTitle) {
      document.title = `${name || "Human"} - ${baseTitle}`;
      return;
    }

    document.title = baseTitle;
  }, [isNewForm, selectedHuman?.name, urlParams.humanId]);

  function getSideBarClassNames() {
    return urlParams.humanId
      ? "md:flex-shrink-0 lg:w-80 bg-gray-100 hidden lg:block h-full"
      : "md:flex-shrink-0 lg:w-80 bg-gray-100 h-full";
  }

  function getRightColumnClassNames() {
    return urlParams.humanId
      ? "bg-gray-100 lg:min-w-0 lg:flex-1 h-full overflow-y-auto overflow-x-hidden"
      : "bg-gray-100 lg:min-w-0 lg:flex-1 h-full hidden lg:block overflow-y-auto overflow-x-hidden";
  }

  if (loadingHumans && humansCount === 0) {
    return <Loading fullPage />;
  }

  return (
    <div
      className="flex-1 lg:flex bg-gray-100 h-full"
      style={{ height: "calc(100vh - 4rem)" }}
    >
      <div className={getSideBarClassNames()}>
        <div className="h-full pt-3 overflow-y-hidden">
          <div className="h-full relative" style={{ minHeight: "12rem" }}>
            <div className="absolute h-full inset-0  rounded-md ">
              <HumanListColumn selectedId={selectedHumanId} />
            </div>
          </div>
        </div>
      </div>

      <div className={getRightColumnClassNames()}>
        <div className="h-full pt-4 lg:pl-4 lg:mr-3">
          <div className="relative h-full">
            <div className="absolute inset-0 rounded-md">
              {isNewForm && (
                <NewHuman
                  key={`NewHuman_${selectedHumanId}`}
                  humanId={selectedHumanId}
                />
              )}

              {!isNewForm && selectedHuman !== undefined && (
                <HumanColumn
                  key={`HumanColumn_${selectedHuman.id}`}
                  human={selectedHuman}
                />
              )}

              {!isNewForm && selectedHuman === undefined && (
                <h3>Human not found</h3>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

Humans.propTypes = {
  location: PropTypes.object,
  humansCount: PropTypes.number,
  selectedHuman: PropTypes.object,
  loadingHumans: PropTypes.bool,
  selectedHumanId: PropTypes.string,
};
export default connect(mapStateToProps)(Humans);
